import { lazy } from 'react';
import { PermissionsGuard } from './components';
import { CREATE_PERMISSION, IMPERSONATE_USER_AUTH } from 'src/constants/permissions';
import { IMPERSONATION_APP_ROUTES } from 'src/modules/impersonation/constants';

export const Routes = [
    {
        exact: true,
        path: IMPERSONATION_APP_ROUTES.MANAGEMENT,
        guard: PermissionsGuard,
        roles: { permission: IMPERSONATE_USER_AUTH, crud: CREATE_PERMISSION },
        component: lazy(() => import('src/views/impersonation/ManageView')),
    },
];

export const PublicRoutes = [
    {
        exact: true,
        path: IMPERSONATION_APP_ROUTES.REVIEW_PATTERN,
        component: lazy(() => import('src/views/impersonation/ReviewView')),
    },
    {
        exact: true,
        path: IMPERSONATION_APP_ROUTES.START_PATTERN,
        component: lazy(() => import('src/views/impersonation/StartView')),
    },
];
